import React from 'react';

import { faCalendar, faChevronDown } from '@fortawesome/pro-regular-svg-icons';

import { Button } from 'components/ui/button';
import DatePicker, { pickedDate } from 'components/ui/date_picker';
import { formatTokens, startOf } from 'helpers/date_utils';
import { DATE_FORMAT, formatDate, ISO_DATE_FORMAT } from 'helpers/formatters/date_time_formats';

interface Props {
  buttonLabel: string;
  date: Date;
  disabled: boolean;
  saving: boolean;
  showDate: boolean;
  onDateChange: (date: Date) => void;
  onSubmit: () => void;
}

export default function PanelFooter({
  buttonLabel,
  date,
  disabled,
  saving,
  showDate,
  onDateChange,
  onSubmit,
}: Props) {
  // activities cannot have occurred in the future
  const today = startOf(new Date(), 'day');

  return (
    <div className="d-flex justify-content-end align-items-center gap-3">
      {showDate && (
        <DatePicker
          align="end"
          disabled={saving}
          disabledDays={{ after: today }}
          required
          saving={saving}
          side="top"
          trigger={
            // Outlined with a chevron so it reads as something to click, not a static date
            <Button
              aria-label={`Activity date, ${formatDate(date, DATE_FORMAT)}. Change date`}
              icon={faCalendar}
              iconEnd={faChevronDown}
              size="sm"
              variant="outline"
            >
              {formatDate(date, DATE_FORMAT)}
            </Button>
          }
          value={formatTokens(date, ISO_DATE_FORMAT)}
          onChange={(picked: string) => {
            const date = pickedDate(picked);
            if (date) onDateChange(date);
          }}
        />
      )}
      <Button disabled={disabled || saving} onClick={onSubmit}>
        {buttonLabel}
      </Button>
    </div>
  );
}
